// extracted by mini-css-extract-plugin
module.exports = {"description":"TrustedAppsCustomRatingSetup_description__28Awn"};